import outboundIcon from '../../assets/outbound.svg';
import outboundIconDark from '../../assets/outbound_dark.svg';

export function OutboundIcon({
  size = 18,
  title,
  filter,
  theme = 'white',
}: {
  size?: number;
  title?: string;
  filter?: string;
  theme?: 'white' | 'dark';
}) {
  return (
    <img
      src={theme === 'white' ? outboundIcon : outboundIconDark}
      alt="Outbound Fax"
      title={title}
      style={{
        width: size,
        height: size,
        filter: filter,
      }}
    />
  );
}
